import { createSlice } from "@reduxjs/toolkit";

export const tabSlice = createSlice({
    name: 'tab',
    initialState: {
        value: "1"
    },
    reducers: {
        setTab: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setTab } = tabSlice.actions;

export const getTab = (state) => state.tab.value;

export default tabSlice.reducer;